export const LOGO_PINK = "/assets/showtime-logo-pink.png";
export const LOGO_MONO = "/assets/showtime-logo-mono.png";

const u = (id, w = 1200) =>
    `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
    hero: u("photo-1693122389795-eea74c1ce549", 2000),
    cottonCandy: u("photo-1693122389795-eea74c1ce549"),
    popcorn: u("photo-1505686994434-e3cc5abf1330"),
    slushie: u("photo-1541288892379-c987c60cd049"),
    wholesale: u("photo-1604719312566-8912e9227c6a", 1600),
    packaged: u("photo-1775813724134-3c4a60fcaa85"),
    eventService: u("photo-1758216535135-2411b8b6c310"),
    girlTreat: u("photo-1770732165197-de91293cc960"),
    familyServe: u("photo-1777368970984-79292f682e84"),
    wedding: u("photo-1561940329-7382e6704231"),
    corporate: u("photo-1540575467063-178a50c2df87"),
    brandActivation: u("photo-1531058020387-3be344556be6"),
    birthday: u("photo-1464349153735-7db50ed83c84"),
    school: u("photo-1503454537195-1dcabb73ffb9"),
    community: u("photo-1517457373958-b7bdd4587205"),
    privateEvent: u("photo-1511795409834-ef04bbd61622"),
    teens: u("photo-1529156069898-49953e39b3ac"),
    familySunset: u("photo-1511895426328-dc8714191300"),
    sparklers: u("photo-1492684223066-81342ee5ff30"),
    about: u("photo-1758216535135-2411b8b6c310"),
};

export const NAV_LINKS = [
    { label: "Shop", to: "/shop" },
    { label: "Book", to: "/book" },
    { label: "Party Packs", to: "/party-packs" },
    { label: "Flavors", to: "/flavors" },
    { label: "Wholesale", to: "/wholesale" },
    { label: "About", to: "/about" },
];

export const FALLBACK_PRODUCTS = [
    { id: "p1", name: "Individual Cotton Candy", category: "Cotton Candy", price: 6, tag: "FRESH SPUN", kind: "cotton_candy" },
    { id: "p2", name: "Cotton Candy 2-Pack", category: "Cotton Candy", price: 11, tag: "MULTIPACK", kind: "cotton_candy" },
    { id: "p3", name: "Cotton Candy 4-Pack", category: "Cotton Candy", price: 20, tag: "BEST SELLER", kind: "cotton_candy" },
    { id: "p4", name: "Cotton Candy Party Pack", category: "Party Packs", price: 45, tag: "SERVES 10", kind: "cotton_candy" },
    { id: "p5", name: "Mystery Flavor Cotton Candy", category: "Mystery", price: 7, tag: "MYSTERY", kind: "cotton_candy" },
    { id: "p6", name: "Individual Popcorn", category: "Popcorn", price: 5, tag: "FRESH POPPED", kind: "popcorn" },
    { id: "p7", name: "Popcorn 2-Pack", category: "Popcorn", price: 9, tag: "MULTIPACK", kind: "popcorn" },
    { id: "p8", name: "Popcorn 4-Pack", category: "Popcorn", price: 16, tag: "BEST SELLER", kind: "popcorn" },
    { id: "p9", name: "Popcorn Party Pack", category: "Party Packs", price: 38, tag: "SERVES 10", kind: "popcorn" },
    { id: "p10", name: "Mystery Flavor Popcorn", category: "Mystery", price: 6, tag: "MYSTERY", kind: "popcorn" },
];

export const FALLBACK_PACKS = [
    { id: "pack1", name: "SMALL PARTY", guests: "Serves up to 15", price: 149, contents: ["15 fresh cotton candy", "15 gourmet popcorn", "Flavor picks included"], featured: false },
    { id: "pack2", name: "MEDIUM PARTY", guests: "Serves up to 30", price: 269, contents: ["30 fresh cotton candy", "30 gourmet popcorn", "Up to 4 flavors", "Mystery flavors on request"], featured: true },
    { id: "pack3", name: "BIG SHOW", guests: "Serves up to 75", price: 549, contents: ["75 fresh cotton candy", "75 gourmet popcorn", "Unlimited flavor mix", "Priority delivery window"], featured: false },
];

export const EXPERIENCES = [
    { title: "Birthday Parties", image: IMAGES.birthday, copy: "Cake is expected. A live cotton candy spin is not." },
    { title: "Corporate Events", image: IMAGES.corporate, copy: "The snack table people actually remember on Monday." },
    { title: "School Events", image: IMAGES.school, copy: "Field days, fundraisers and celebrations, upgraded." },
    { title: "Community Events", image: IMAGES.community, copy: "Block parties to street fairs — we bring the crowd a treat." },
    { title: "Brand Activations", image: IMAGES.brandActivation, copy: "Photogenic, custom-colored spins built for the feed." },
    { title: "Weddings & Celebrations", image: IMAGES.wedding, copy: "A late-night sweet your guests will talk about." },
    { title: "Private Events", image: IMAGES.privateEvent, copy: "Rooftops, backyards, lofts. If there's a crowd, there's a show." },
];
